import type { Organization } from "@/types/organization";

import { getMockMarketProfile } from "../market";

import { createId, createPastDate } from "./base";

import { FEATURE_FLAG } from "@/types/feature-flag";

/**
 * Generate a mock clinic organization
 */
export function generateOrganization(): Organization {
  const createdAt = createPastDate(90);
  const profile = getMockMarketProfile();

  return {
    id: createId(),
    name: profile.organizationName,
    slug: profile.organizationSlug,
    phoneNumber: profile.organizationPhone,
    website: profile.organizationWebsite,
    currency: profile.currency,
    type: "clinic",
    timezone: profile.timezone,
    region: profile.region,
    featureFlags: { [FEATURE_FLAG.STRIPE_PAYMENTS]: true },
    createdAt,
    updatedAt: createdAt,
  };
}

/**
 * Generate an e-commerce organization for testing
 */
export function generateEcommerceOrganization(): Organization {
  const createdAt = createPastDate(90);
  const profile = getMockMarketProfile();

  return {
    id: createId(),
    name: "ACME Shop",
    slug: "acme-shop",
    phoneNumber: "+1 (555) 987-6543",
    website: "https://acmeshop.com",
    currency: profile.currency,
    type: "ecommerce",
    timezone: profile.timezone,
    region: profile.region,
    createdAt,
    updatedAt: createdAt,
  };
}
